import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	Reconciliation,
	ReconciliationQueryParams,
	DataUpdateReconciliation,
} from "../types";

interface ReconciliationState {
	reconciliationList: Array<Reconciliation>;
	reconciliationTotal: number;
	loading: boolean;
	reconciliationDetail: Reconciliation | null;
}

const initialState: ReconciliationState = {
	loading: false,
	reconciliationList: [],
	reconciliationTotal: 0,
	reconciliationDetail: null,
};

export const reconciliationSlice = createSlice({
	name: "reconciliation",
	initialState,
	reducers: {
		setListReconciliation: (state, action) => {
			state.reconciliationList = action.payload.data;
			state.reconciliationTotal = action.payload.total;
		},
		setDetailReconciliation: (state, action) => {
			state.reconciliationDetail = action.payload;
		},
		setLoadingReconciliation: (state, action) => {
			state.loading = action.payload;
		},
	},
});

export const selectReconciliationList = (state: RootState) =>
	state.reconciliation.reconciliationList;
export const selectReconciliationTotal = (state: RootState) =>
	state.reconciliation.reconciliationTotal;
export const selectReconciliationDetail = (state: RootState) =>
	state.reconciliation.reconciliationDetail;
export const selectLoading = (state: RootState) => state.reconciliation.loading;

export const {
	setListReconciliation,
	setDetailReconciliation,
	setLoadingReconciliation,
} = reconciliationSlice.actions;

export interface GetListReconciliationAsyncPayload {
	query: ReconciliationQueryParams;
	callback?: () => void;
}
export const getListReconciliationAsync = createAction(
	"reconciliation/getListReconciliationAsync",
	(payload: GetListReconciliationAsyncPayload) => ({
		payload: payload,
	}),
);

// Detail
export interface GetDetailReconciliationAsyncPayload {
	id: string | number;
}
export const getDetailReconciliationAsync = createAction(
	"reconciliation/getDetailReconciliationAsync",
	(payload: GetDetailReconciliationAsyncPayload) => ({
		payload,
	}),
);

// Update
export interface UpdateReconciliationAsyncPayload {
	data: DataUpdateReconciliation;
	id: string;
	getResult: (arg: { success: boolean }) => void;
}
export const updateReconciliationAsync = createAction(
	"reconciliation/updateReconciliationAsync",
	(payload: UpdateReconciliationAsyncPayload) => ({
		payload,
	}),
);

export default reconciliationSlice.reducer;
